module.exports = __webpack_public_path__ + "static/media/agreement.9c2c3667.svg";